var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../service/api.service';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
var KtsMultiSelectPartnerUserService = /** @class */ (function (_super) {
    __extends(KtsMultiSelectPartnerUserService, _super);
    function KtsMultiSelectPartnerUserService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this._subject = new BehaviorSubject(false);
        return _this;
    }
    KtsMultiSelectPartnerUserService.prototype.init = function () {
        this._subject.next(false);
    };
    Object.defineProperty(KtsMultiSelectPartnerUserService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    KtsMultiSelectPartnerUserService.prototype.checkItem = function (cols, rec) {
        var items = rec[cols[0].key] || [];
        var its = [];
        var check = true;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.$type === "delete" /* Delete */) {
                continue;
            }
            its.push(item);
        }
        if (cols[0].required && its.length === 0) {
            check = false;
            this._subject.next(true);
        }
        return check;
    };
    KtsMultiSelectPartnerUserService.prototype.sortItems = function (items, key) {
        items.sort(function (a, b) {
            if (a[key] < b[key]) {
                return -1;
            }
            if (a[key] > b[key]) {
                return 1;
            }
            return 0;
        });
    };
    KtsMultiSelectPartnerUserService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsMultiSelectPartnerUserService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return KtsMultiSelectPartnerUserService;
}(ContentBaseService));
export { KtsMultiSelectPartnerUserService };
var List = /** @class */ (function () {
    function List() {
    }
    return List;
}());
export { List };
var Item = /** @class */ (function () {
    function Item() {
        this.$type = "post" /* Post */;
    }
    return Item;
}());
export { Item };
var ListUser = /** @class */ (function () {
    function ListUser() {
    }
    return ListUser;
}());
export { ListUser };
var UserItem = /** @class */ (function () {
    function UserItem() {
        this.$type = "post" /* Post */;
    }
    return UserItem;
}());
export { UserItem };
//# sourceMappingURL=multiselect-partner-user.service.js.map